export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5228.30a87ed0.jpg";